import { Injectable, inject } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ITplSearchArbetsorderQueryResult, ITplTransportforetagHandelssortimentDto, ITransportforetag, TplTransportforetagHandelssortimentQuery } from "../models/queries";
import { ITplState, SharedState, State, TplTabId } from "./state-models";

@Injectable({
    providedIn: "root"
})
export class TplStateService {
    currentState: BehaviorSubject<ITplState> = new BehaviorSubject<ITplState>(null);
    init: BehaviorSubject<ITplState> = new BehaviorSubject<ITplState>(this.currentState.value);
    states: ITplState[];

    private readonly apiClient = inject(ApiClientService);

    constructor() {
        const shared = new SharedState();
        this.load(shared);
        this.states = [
            new State(TplTabId.search, shared),
            new State(TplTabId.filter, shared),
            new State(TplTabId.transporttilldelning, shared, true),
            new State(TplTabId.omdestinera, shared),
            new State(TplTabId.handelser, shared),
            new State(TplTabId.hanteraao, shared)
        ];
        this.select(TplTabId.search);
    }

    get current(): ITplState {
        return this.currentState.value;
    }

    clear() {
        this.currentState.value.arbetsordrar.next([]);
        this.currentState.value.currentArbetsordrar.next([]);
        this.currentState.value.maskinlag.next([]);
        this.currentState.value.filteredTransportforetag.next([]);
        this.currentState.value.selected.next({ selected: [],
            origin: "" });
        this.currentState.value.transportsatt.next({ rundvirke: false,
            bransle: false });
        this.currentState.value.modifiedArbetsordrar.next([]);
        this.currentState.value.arbetsorderHandelssortiment.next([]);
        this.currentState.value.arbetsordrarDestinering.next([]);
        this.currentState.value.selectedHs.next(null);
        this.currentState.value.destineringHs.next(null);
        this.currentState.value.selectedMottagningsplatser.next(null);
        this.currentState.value.selectedVaglager.next(null);
    }

    initialize(arbetsordrar: ITplSearchArbetsorderQueryResult) {
        this.apiClient
            .post<TplTransportforetagHandelssortimentQuery, ITplTransportforetagHandelssortimentDto[]>(
                "transportplanera/arbetsorder/handelssortiment",
                new TplTransportforetagHandelssortimentQuery(arbetsordrar.arbetsorderList.map(x => x.id)), false)
            .subscribe(res => {
                this.current.setSelected({ selected: [],
                    origin: "map" });
                this.current.setMaskinlag(arbetsordrar.maskinlagList);
                this.current.setFilteredTransportforetag(arbetsordrar.transportforetagList);
                this.current.setArbetsorderHandelssortiment(res);
                this.current.setArbetsordrar(arbetsordrar.arbetsorderList);
                this.current.setCurrentArbetsordrar(arbetsordrar.arbetsorderList);
                setTimeout(() => {
                    this.init.next(this.currentState.value);
                });
            });
    }

    select(name: string) {
        if (name === this.currentState?.value?.name) {
            return;
        }
        const state = this.states.find(x => x.name === name);
        if (!state) {
            throw new Error((`State not found: ${name}`));
        } else {
            this.currentState.next(state);
        }
    }

    private load(sharedState: SharedState) {
        return this.apiClient.getCached<ITransportforetag[]>("transportforetag", false).subscribe(tf => {
            sharedState.transportforetag.next(tf);
        });
    }
}
